import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ImportJobDto } from '../../../models/user/dto/import-job.dto';
import { getImportJobQueryKey } from './useGetImportJob';

/**
 * Two-phase preview, phase 2: approve the server-validated counts and queue the
 * import. Only a READY job can be confirmed; the cron then picks it up.
 */
export const useConfirmImportJob = (organizationId: string) => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (jobId: string) =>
      client.fetchApi<ImportJobDto, undefined>({
        endpoint: `users/imports/${jobId}/confirm?organizationId=${organizationId}`,
        method: 'POST',
      }),
    // Restart the poller. useGetImportJob stops refetching at READY (nothing
    // changes while it waits on a human), so confirming has to push the new
    // status into the cache itself — otherwise the cached job stays READY, the
    // interval is never re-evaluated, and the modal sits on "ready to import"
    // forever while the cron runs the import behind it. Seeding the response
    // (already PENDING) both re-renders the panel and resumes the 2s poll.
    onSuccess: (job, jobId) => {
      queryClient.setQueryData(getImportJobQueryKey(organizationId, jobId), job);
    },
  });
};
